export const environment = {
  production: true,
  envName: 'prod',
  autoClub: 'W2C',  	
  addressify: {
    baseUrl: 'https://api.addressify.com.au',
  },
  baseAPIUrl: 'https://apim-aue-ltx-prod-api-01.azure-api.net/v1/quote/api/',
  PASUrl: 'https://pas.tmaainsurance.com',
  WebhookUrl: 'https://fa-prod-aue-ltx-webhook-api-ivr.azurewebsites.net',
  TwilStartUrl: '/StartPayment?code=0fG4z5BOkWss7NBzGnofjTBskgWD2Vbt9v2fWk5Mu-_8AzFu3WRMAw==',
  TwilCaptureUrl: '/CaptureOrReset?code=Ud-mn0cJEmSnMWoXPKwDCfMUcf5E-WB6ef3mokX_i0U6AzFubn4s8w==',
  ManageGroupUrl: '/ManageGroup?code=T-fDcKcbeV5hXHYKkTm627pqRA6gfxvV4Eql2-SrNsLeAzFuNNmUwA==',
  VeriskRootUrl: 'https://gateway.verisk.com/rating/au/travel/',
  VeriskCssUrl:
    'https://blackbox30-travel.verisk.com.au/Content/BootstrapVerisk.css',
  VeriskBlackboxUrl:
    'https://blackbox30-travel.verisk.com.au/Scripts/blackbox-3.1.0.js',
  VeriskDecryptUrl:
    'https://gateway.verisk.com/rating/au/travel/calculation/decrypt/v2',
  VeriskRescoreUrl:
    'https://gateway.verisk.com/rating/au/travel/calculation/rescore/v2',
  GooglePayMerchantId: 'BCR2DN4TSPPI7DAO'
};